import { render, staticRenderFns } from "./MemberDetailsView.vue?vue&type=template&id=2a8b084b"
import script from "./MemberDetailsView.vue?vue&type=script&lang=ts"
export * from "./MemberDetailsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports